import * as React from 'react';
import { ComponentProps } from 'react';
import { MarketList, MarketRow, MarketSelect } from '@market/react-bindings';
import { MarketSelectCustomEvent } from '@market/web-components/dist/types/components';

export type MarketSelectOption = {
  value: string;
  label: string | React.ReactNode;
  subtext?: string | React.ReactNode;
  disabled?: boolean;
};

export type MarketSelectInputProps = Omit<ComponentProps<typeof MarketSelect>, 'onMarketSelectValueDidChange' | 'onChange' | 'content'> & {
  label?: string;
  onChange(
    e: MarketSelectCustomEvent<{
      value: string | Array<any>;
      newSelectedOption: HTMLMarketRowElement;
      newDeselectedOption: HTMLMarketRowElement;
      currentSelectedOptions: Array<HTMLMarketRowElement>;
    }>,
  ): void;
  hasError?: boolean;
  options?: MarketSelectOption[];
  content?: React.ReactNode;
};

// passing onBlur prop to MarketSelect cause unexpected behaviour
export const MarketSelectInput: React.FC<MarketSelectInputProps> = ({ label, options = [], disabled, onChange, content, onBlur, hasError, ...props }) => {
  return (
    <MarketSelect {...props} name={label} onMarketSelectValueDidChange={onChange} disabled={disabled || undefined} invalid={hasError || undefined}>
      <label>{label}</label>
      {content ? (
        content
      ) : (
        <MarketList slot="list">
          {options.map((o) => (
            <MarketRow key={o.value} value={o.value} disabled={o.disabled || undefined}>
              <label slot="label">{o.label}</label>
              {o.subtext && (
                <p className="tw-m-0" slot="subtext">
                  {o.subtext}
                </p>
              )}
            </MarketRow>
          ))}
        </MarketList>
      )}
    </MarketSelect>
  );
};
